export const throwError = (error) => {
    throw new Error(error?.response?.data || error);
};
